import { useEffect } from 'react';

const BASE_TITLE = 'Propo CRM';

/**
 * Sayfa başlığını dinamik olarak günceleyen custom hook.
 * 
 * Kullanım:
 *   usePageTitle('Dashboard')           → "Dashboard | Propo CRM"
 *   usePageTitle()                      → "Propo CRM"
 *   usePageTitle('Proje Detay', [data]) → data yüklendiğinde title güncellenir
 * 
 * @param {string} title - Sayfa başlığı
 * @param {Array} deps - Opsiyonel bağımlılık dizisi (dinamik title'lar için)
 */
const usePageTitle = (title, deps = []) => {
  useEffect(() => {
    const previousTitle = document.title;

    if (title) {
      document.title = `${title} | ${BASE_TITLE}`;
    } else {
      document.title = BASE_TITLE;
    }

    // Component unmount olduğunda önceki title'a geri dön
    return () => {
      document.title = previousTitle;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, ...deps]);
};

export default usePageTitle;
